import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";

@Component
export default class HandoffShared extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("infusions", patientNamespace)
  infusions!: any;

  @Getter("now", patientNamespace)
  now!: any;
}
